import React from 'react';
import { Link } from '@fluentui/react-components';
import { OpenRegular } from '@fluentui/react-icons';
import { makeStyles, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '10px 24px',
    backgroundColor: tokens.colorNeutralBackground2,
    flexShrink: 0,
  },
  link: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    fontSize: tokens.fontSizeBase200,
  },
});

export const Footer: React.FC = () => {
  const styles = useStyles();

  return (
    <footer className={styles.footer}>
      <Link
        href="https://www.microsoft.com/en-us/privacy/data-privacy-notice"
        target="_blank"
        rel="noopener noreferrer"
        className={styles.link}
      >
        Data Privacy Notice
        <OpenRegular />
      </Link>
    </footer>
  );
};
